var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMicrophone = function SvgMicrophone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 .75A3.75 3.75 0 0 0 8.25 4.5v8.25a3.75 3.75 0 1 0 7.5 0V4.5A3.75 3.75 0 0 0 12 .75M9.75 4.5a2.25 2.25 0 1 1 4.5 0v8.25a2.25 2.25 0 1 1-4.5 0z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.75 11.25a.75.75 0 0 0-1.5 0v1.5a6.75 6.75 0 0 0 6 6.709v2.291h-3a.75.75 0 0 0 0 1.5h7.5a.75.75 0 0 0 0-1.5h-3v-2.291a6.75 6.75 0 0 0 6-6.709v-1.5a.75.75 0 0 0-1.5 0v1.5a5.25 5.25 0 1 1-10.5 0z"
  })));
};
export default SvgMicrophone;